
export default function StorySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Why We Created This Program
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                After years of teaching English to students from around the world, we noticed a problem. 
                Traditional methods were too slow, too complicated, and focused on the wrong things.
              </p>
              <p>
                Students spent months learning grammar rules they'd never use, memorizing vocabulary 
                that wasn't practical, and still couldn't have a simple conversation with a native speaker.
              </p>
              <p className="font-semibold text-gray-900">
                We knew there had to be a better way.
              </p>
              <p>
                So we developed a method that focuses on what really matters: the English you'll actually 
                use in real life. Simple grammar explanations, useful vocabulary, clear pronunciation, 
                and the slang that helps you sound natural.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/812f90b70634ec9a2e64a00d1285d792.jpg"
              alt="Our teaching approach"
              className="rounded-2xl shadow-lg object-cover object-top w-full h-96"
            />
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-xl shadow-lg">
              <div className="text-center">
                <div className="text-2xl font-bold">5000+</div>
                <div className="text-sm">Happy Students</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
